import { render, staticRenderFns } from "./SocialsAppeal.vue?vue&type=template&id=26a56410&scoped=true"
import script from "./SocialsAppeal.vue?vue&type=script&lang=js"
export * from "./SocialsAppeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a56410",
  null
  
)

export default component.exports